import type { BrandingConfig } from "./types";

import appHorizontalSplitLight from "../../assets/brand/tenants/default/app/logo-horizontal-split-light-glow.svg";
import appHorizontalSplitDark from "../../assets/brand/tenants/default/app/logo-horizontal-split-dark-glow.svg";
import appHorizontalLockupLight from "../../assets/brand/tenants/default/app/logo-horizontal-lockup-light-web.svg";
import appHorizontalLockupDark from "../../assets/brand/tenants/default/app/logo-horizontal-lockup-dark.svg";
import appStackedLight from "../../assets/brand/tenants/default/app/logo-stacked-light.svg";
import appStackedDark from "../../assets/brand/tenants/default/app/logo-stacked-dark.svg";
import appSymbolLight from "../../assets/brand/tenants/default/app/logo-symbol-light.svg";
import appSymbolDark from "../../assets/brand/tenants/default/app/logo-symbol-dark.svg";

import companyHorizontalLight from "../../assets/brand/tenants/default/company/logo-horizontal-light.svg";
import companyHorizontalDark from "../../assets/brand/tenants/default/company/logo-horizontal-dark.svg";
import companyStackedLight from "../../assets/brand/tenants/default/company/logo-stacked-light.svg";
import companyStackedDark from "../../assets/brand/tenants/default/company/logo-stacked-dark.svg";
import companySymbolLight from "../../assets/brand/tenants/default/company/logo-symbol-light.svg";
import companySymbolDark from "../../assets/brand/tenants/default/company/logo-symbol-dark.svg";

import brandCopy from "./brand-copy.json";

import ogImage from "../../assets/brand/tenants/default/social/og-image.jpg";

export const defaultBranding: BrandingConfig = {
  tenantId: "trade-proof",
  appName: "Trade-Proof",
  companyName: "Trade-Proof",
  whiteLabel: false,
  showPoweredBy: true,
  signupFlow: 'checkout',
  copy: brandCopy["trade-proof"],
  supportEmail: "support@trade-proof.com",
  websiteUrl: "https://trade-proof.com",
  logos: {
    app: {
      horizontalSplitLight: appHorizontalSplitLight,
      horizontalSplitDark: appHorizontalSplitDark,
      horizontalLockupLight: appHorizontalLockupLight,
      horizontalLockupDark: appHorizontalLockupDark,
      stackedLight: appStackedLight,
      stackedDark: appStackedDark,
      symbolLight: appSymbolLight,
      symbolDark: appSymbolDark,
    },
    company: {
      horizontalLight: companyHorizontalLight,
      horizontalDark: companyHorizontalDark,
      stackedLight: companyStackedLight,
      stackedDark: companyStackedDark,
      symbolLight: companySymbolLight,
      symbolDark: companySymbolDark,
    },
    appLogoSizing: {
      horizontalSplit: { scale: 1 },
      horizontalLockup: { scale: 1 },
      stacked: { scale: 1 },
      symbol: { scale: 1.2 },
    },
    companyLogoSizing: {
      horizontal: { scale: 1 },
      stacked: { scale: 1 },
      symbol: { scale: 1 },
    },
    topNavLogoScale: 1.2,
    navLogoGlow: {
      glowOpacityLight: 0.04,
      glowOpacityDark: 0.46,
      shieldOpacityLight: 0.08,
      shieldOpacityDark: 0.5,
      // Top-nav shield glow — intentionally slightly stronger than the loading-page
      // glow (index.html #bootstrap-shell .workspace-loader__brand-logo filter) so
      // the cyan rim reads clearly in the header without becoming a broad spotlight.
      shieldFilterLight: 'drop-shadow(0 0 6px rgba(96, 165, 250, 0.46)) drop-shadow(0 0 16px rgba(56, 189, 248, 0.24)) brightness(1.25) contrast(1.06)',
      shieldFilterDark: 'drop-shadow(0 0 6px rgba(96, 165, 250, 0.46)) drop-shadow(0 0 16px rgba(56, 189, 248, 0.24)) brightness(1.25) contrast(1.06)',
      haloWidth: 100,
      haloHeight: 100,
      haloOffsetX: 2.55,
      haloOffsetY: 0,
      haloBlur: 4,
    },
    favicon: "/favicon.ico",
    faviconSvg: "/favicon.svg",
    appleTouchIcon: "/apple-touch-icon.png",
    manifest: "/site.webmanifest",
    ogImage,
  },
};

export default defaultBranding;
